import { render, staticRenderFns } from "./ElementScalePartTopTableColumn.vue?vue&type=template&id=5e796b1e&scoped=true"
import script from "./ElementScalePartTopTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementScalePartTopTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementScalePartTopTableColumn.vue?vue&type=style&index=0&id=5e796b1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e796b1e",
  null
  
)

export default component.exports